import { z } from "zod";

export const OrganizationResponseSchema = z
  .object({
    id: z.string().min(1),
    name: z.string().min(1),
    slug: z.string().min(1),
    logoUrl: z.url().nullable(),
    customerDomain: z.string().nullable(),
  })
  .strict();

export type OrganizationResponse = z.infer<typeof OrganizationResponseSchema>;

export const ListOrganizationsResponseSchema = z
  .object({
    items: z.array(OrganizationResponseSchema),
  })
  .strict();

export type ListOrganizationsResponse = z.infer<typeof ListOrganizationsResponseSchema>;
